module.exports = __webpack_public_path__ + "media/images/emblems/Aranno-coat_of_arms-7676b7209d188fe1b8e65a2574f79803.svg";